import classNames from 'classnames/bind';
import styles from './UserInfo.module.scss';
import { IconName } from '../../components/Icon/utils/types';
import Icon from '../../components/Icon/Icon';
import { useAuth0 } from '@auth0/auth0-react';

const cx = classNames.bind(styles);

interface UserInfoProps {
  email?: string;
}

const UserInfo = (props: UserInfoProps) => {
  const { email } = props;

  const { logout } = useAuth0();

  const onLogout = () =>
    logout({ logoutParams: { returnTo: window.location.origin } });

  return (
    <div className={cx('user-info')}>
      <div>Hello, {email}</div>
      <div className={cx('user-info__options')}>
        <a
          className={cx('user-info__button')}
          target="_blank"
          rel="noreferrer"
          href="https://dfinfilermanagement.zendesk.com/hc/en-us"
        >
          <Icon name={IconName.Help} width={16} height={16} />
          Help
        </a>
        <div onClick={onLogout} className={cx('user-info__button')}>
          <Icon name={IconName.Exit} width={16} height={16} />
          Log out
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
